<template>
    <div>
        <loading :active.sync="isLoading" :can-cancel="true"></loading>
        <online-lecture-list
                :lecture-info="lectureInfo"
                :width-css="widthCss"
                :double-info="doubleInfo"
                :category-id=categoryId
                :pay-buttons=payButtons
                :is-membership-lectures=isMembershipLectures
                :sub-site=subSite
                :multiple-play-popup=multiplePlayPopup>
        </online-lecture-list>
    </div>
</template>

<script>
import Axios from 'axios';
import Loading from 'vue-loading-overlay';

import OnlineLectureList from './online-lecture-list';

export default {
  props: {
    withSubject: { type: Boolean, default: true },
    randSubject: { type: Boolean, default: true },
    doubleInfo: { type: Boolean, default: true },
    payButtons: { type: Boolean, default: true },
    multiplePlayPopup: { type: Boolean, default: true },
    widthCss: { type: String, default: 'w960' },
    paymentSetting: { type: String, default: 'myclass.dangi.co.kr' },
    subSite: { type: String, default: 'gong' },
  },
  name: 'online-lecture-simple',
  created() {
    if (typeof payment_setting === 'function') {
      payment_setting({ domain: this.paymentSetting });
    } else {
      console.log('결제 라이브러리 호출 실패');
    }

    this.$EventBus.$on('setCallParams', this.setCallParams);
    this.$EventBus.$on('getLectureListByCategoryId', this.getLectureListByCategoryId);
  },
  data() {
    return {
      isMembershipLectures: false,
      categoryId: NaN,
      year: null,
      levelType: null,
      teacherId: null,
      isLoading: false,
      subjectCategoryId: NaN,
      subjectCategoryName: null,
      subjectList: [],
      lectureInfo: {},
    };
  },
  methods: {
    setCallParams(args) {
      let callLectures = false;
      switch (args.key) {
        case 'year':
          this.year = args.value;
          break;

        case 'levelType':
          this.levelType = args.value;
          break;

        case 'teacherId':
          this.teacherId = args.value;
          break;

        default:
          return false;
      }

      callLectures = args.callLecture;

      if (Object.hasOwnProperty.call(args, 'callLecture') && typeof args.callLecture === 'boolean') {
        if (args.callLecture === true) {
          this.getLectureListByCategoryId({ category: this.subjectCategoryId, });
        }
      } else {
        this.getLectureListByCategoryId({ category: this.subjectCategoryId, });
      }
    },
    getLectureListByCategoryId(categoryInfo) {
      if (typeof categoryInfo === 'object') {
        if (Object.hasOwnProperty.call(categoryInfo, 'category') === true) {
          this.subjectCategoryId = parseInt(categoryInfo.category, 10);
        }
      } else if (typeof categoryInfo === 'number') {
        this.subjectCategoryId = categoryInfo;
      } else {
        this.subjectCategoryId = parseInt(categoryInfo, 10);
      }

      this.isLoading = true;
      const callUrl = this.makeCallUrl(`/gong/lecture/lecture_ajax/ax_get_LectureListByCategoryId/${this.subjectCategoryId}`);

      Axios.get(callUrl).then((response) => {
        if (Object.prototype.hasOwnProperty.call(response.data, 'result') === true) {
          const nowResult = response.data.result;
          this.lectureInfo = {};
          if (Object.prototype.hasOwnProperty.call(nowResult.teacherLectureList, 'length') === true && nowResult.teacherLectureList.length > 0) {
            this.lectureInfo = nowResult;
          }
        } else {
          this.lectureInfo = {};
        }

        this.isLoading = false;
      });
    },
    makeCallUrl(baseUrl) {
      let callUrl = baseUrl;
      const addParams = [];

      if (this.year !== null && this.year.length > 1) {
        addParams.push(`year=${this.year}`);
      }

      if (this.levelType !== null && this.levelType.length > 1) {
        addParams.push(`levelType=${this.levelType}`);
      }

      if (this.teacherId !== null && this.teacherId.length > 0) {
        addParams.push(`teacherId=${this.teacherId}`);
      }

      if (addParams.length > 0) {
        const paramsStr = addParams.join('&');
        callUrl += `?${paramsStr}`;
      }

      return callUrl;
    },
  },
  components: {
    Loading,
    'online-lecture-list': OnlineLectureList,
  },
};
</script>



// WEBPACK FOOTER //
// src/Lecture/components/online-lecture-simple.vue